import { render, staticRenderFns } from "./PersonalAlreadyRealName.vue?vue&type=template&id=ffe5ca4e&scoped=true&"
import script from "./PersonalAlreadyRealName.vue?vue&type=script&lang=js&"
export * from "./PersonalAlreadyRealName.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAlreadyRealName.vue?vue&type=style&index=0&id=ffe5ca4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe5ca4e",
  null
  
)

export default component.exports